const quotePageStyle = (theme) => ({
  card: {
    margin: "15px",
  },
  partnerSection: {
    ...theme.arrowItem,
  },
  arrowTipItem: {
    ...theme.arrowTipItem,
  },
  partnerName: {
    ...theme.ellipsisLabel,
    fontFamily: "SparBd",
    fontSize: "14px",
  },
  quoteInfo: {
    height: "90px",
    "& $buttonStyle": {
      paddingTop: 10,
      "& span": {
        flexDirection: "column",
        fontSize: "11px",
        textTransform: "lowercase",
      },
    },
  },
  quoteInfoUpperSection: { height: "72px" },
  quoteInfoUpperSectionLeft: {
    height: "100%",
    paddingLeft: 10,
  },
  quoteInfoUpperSectionRight: {
    height: "100%",
  },
  quoteInfoLowerSection: {
    padding: "0px 10px 0px 10px",
    color: "white",
    background: (props) => props.statusColor,
    fontSize: "11px",
    height: "18px",
  },
  quoteInfoAssetsSection: {
    paddingTop: 5,
  },
  quoteInfoProductSection: {
    borderLeft: "1px solid",
    paddingLeft: 20,
    paddingTop: 5,
  },
  decisionSection: {
    height: "100%",
  },
  nextActionSection: {
    borderLeft: "1px solid",
    textAlign: "center",
    fontSize: "10px",
    height: "100%",
    padding: "5px",
    width: 210,
  },
  financialSection: {
    padding: "5px 10px 0px 10px",
    borderLeft: "1px solid",
  },
  iconStyle: {
    height: "30px",
    width: "30px",
  },
  productType: {
    background: theme.palette.timColors.grayColor,
    fontSize: "10px",
    color: "white",
    textAlign: "center",
    whiteSpace: "nowrap",
    fontFamily: "SparBd",
  },
  scheduleType: {
    fontSize: "11px",
    textAlign: "center",
  },
  typography: {
    ...theme.typography,
  },
  reducedFont: {
    fontSize: "11px",
    whiteSpace: "nowrap",
    textTransform: "none",
  },
  minFont: {
    fontSize: "12px",
    whiteSpace: "nowrap",
  },
  minFontLabel: {
    color: "#999",
    fontSize: "10px",
    whiteSpace: "nowrap",
  },
  wizardInfo: {
    height: "35px",
    backgroundColor: "#e5e5e5",
  },
  wizardCompanyName: {
    backgroundColor: theme.palette.timColors.grayColor,
    color: "#fff",
    fontSize: "14px",
    "& span": { fontFamily: "SparBd" },
  },
  wizardCurrency: {
    width: "auto",
    maxWidth: "98px",
    minWidth: "98px",
    height: "35px",
    backgroundColor: theme.palette.timColors.grayColor,
    color: "#fff",
    lineHeight: "33px",
    paddingLeft: "10px",
    marginRight: "10px",
    fontSize: "14px",
  },
  fontSize12: {
    fontSize: "12px",
  },
  paperQuoteHeader: {
    marginBottom: "2px",
  },
  paperDialog: {
    padding: "5px",
    fontSize: "12px",
  },
  btnWizard: {
    height: "100%",
    paddingBottom: "3px",
    paddingTop: "3px",
    borderRadius: "0px",
    width: "100%",
  },
  labelWizard: {
    paddingBottom: "0px",
    color: theme.palette.timColors.grayColor,
  },
  gridItemWizard: {
    paddingBottom: "0px",
    paddingTop: "2px",
  },
  grayColor: {
    color: theme.palette.timColors.grayColor,
  },
  width45: {
    width: "45vh",
  },
  width75: {
    width: "75vh",
  },
  height100: {
    height: "100%",
  },
  quoteItemPosition: {
    padding: "10px 10px 0px 10px",
    width: 120,
  },
  financialSectionData: {
    minWidth: 85,
    maxWidth: 85,
  },
  buttonStyle: { minWidth: 64, maxWidth: 64 },
  zootDocDecision: (props) => {
    return {
      color: props.colorDecision || "White",
      height: "23px",
      width: "23px",
      backgroundColor: "transparent",
      borderRadius: "50%",
      boxShadow: "0 2px 2px 0 rgb(153 153 153), 0 3px 1px -2px rgb(153 153 153), 0 1px 5px 0 rgb(153 153 153)",
    };
  },
  headerCaption: {
    width: "80%",
  },
});

export const quoteFooterStyles = () => {
  return {
    footerButton: {
      margin: "0 10px 0 10px",
      padding: "4px 8px",
      fontSize: "12px",
    },
    footerActionsBar: {
      height: 45,
      background: "white",
    },
    footerStatusBar: {
      height: 23,
      color: "white",
      background: (props) => props?.listQuoteItem?.statusColorCode || "#D3D3D3",
      fontSize: "12px",
      padding: "0 15px 0 15px",
    },
  };
};

export const quoteStepperConnectorStyles = (_theme) => {
  return {
    alternativeLabel: {
      top: 10,
      left: "calc(-50% + 16px)",
      right: "calc(50% + 16px)",
    },
    active: {
      "& $line": {
        borderColor: "#ee0000",
      },
    },
    completed: {
      "& $line": {
        borderColor: "#ee0000",
      },
    },
    line: {
      borderColor: "#eaeaf0",
      borderTopWidth: 3,
      borderRadius: 1,
    },
  };
};

export default quotePageStyle;
